'use client';

import classnames from 'classnames';
import { Button } from '@components/v3/atoms/button';
import { UseClient } from '@components/helpers/use-client';
import styles from './infiniteLoader.module.scss';
import { InfiniteLoaderProps } from './infiniteLoader.types';

function InfiniteLoader<T>({
  as: Tag = 'section',
  items,
  render,
  showLoadMoreButton,
  loadMoreButton,
  classNames = [],
  nativeProps = {},
}: InfiniteLoaderProps<T>) {
  const classes = classnames([styles.infiniteLoader], classNames);

  return (
    <Tag {...nativeProps} className={classes}>
      {items && render(items)}

      {showLoadMoreButton && loadMoreButton && (
        <UseClient>
          <div className={styles.loadMore}>
            <Button {...loadMoreButton} />
          </div>
        </UseClient>
      )}
    </Tag>
  );
}

export default InfiniteLoader;
